import { ParametersExceptFirst } from 'ia-react-core/~/interfaces/ParametersExceptFirst';
import { ActionMap } from 'ia-react-core/~/interfaces/ReducerActions';
import moveWorkflowBackwardById from '../../../actions/workflow-fn/moveWorkflowBackwardById';
import moveWorkflowForwardById from '../../../actions/workflow-fn/moveWorkflowForwardById';
import moveWorkflowToStepById from '../../../actions/workflow-fn/moveWorkflowToStepById';
import commitWorkflowStepById from '../../../actions/workflow-fn/commitWorkflowStepById';
import { WorkflowComposedProps } from './Workflow';

const workflowActions = ({ workflowId }: WorkflowComposedProps) => ({
  moveBackward: (...args: ParametersExceptFirst<typeof moveWorkflowBackwardById>) => moveWorkflowBackwardById(workflowId, ...args),
  moveForward: (...args: ParametersExceptFirst<typeof moveWorkflowForwardById>) => moveWorkflowForwardById(workflowId, ...args),
  moveToStep: (...args: ParametersExceptFirst<typeof moveWorkflowToStepById>) => moveWorkflowToStepById(workflowId, ...args),
  commitStep: (...args: ParametersExceptFirst<typeof commitWorkflowStepById>) => commitWorkflowStepById(workflowId, ...args),
} as ActionMap);

export default workflowActions;
